// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_ACTIVITY_LOG_LIST = 'activity-log/SET_ACTIVITY_LOG_LIST';
export const APPEND_ACTIVITY_LOGS = 'activity-log/APPEND_ACTIVITY_LOGS';
